import { useAuth } from '../contexts/AuthContext';
import { useLocale } from '../contexts/LocaleContext';
import { useToast } from '../contexts/ToastContext';
import { API_BASE } from '../config';

interface UseUnresolveCommentOptions {
  onCommentsUpdated?: () => Promise<void> | void;
}

interface UseUnresolveCommentResult {
  unresolveComment: (commentId: string) => Promise<boolean>;
}

export const useUnresolveComment = (options: UseUnresolveCommentOptions = {}): UseUnresolveCommentResult => {
  const { token } = useAuth();
  const { t } = useLocale();
  const { showToast, showErrorToast } = useToast();

  const unresolveComment = async (commentId: string): Promise<boolean> => {
    if (!token) {
      return false;
    }

    try {
      const response = await fetch(`${API_BASE}/api/comments/${commentId}/unresolve`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        showToast(t('comment_unresolved'));
        if (options.onCommentsUpdated) {
          await options.onCommentsUpdated();
        }
        return true;
      }

      showErrorToast(t('failed_to_unresolve_comment'));
      return false;
    } catch (err) {
      console.error('Error unresolving comment:', err);
      showErrorToast(t('failed_to_unresolve_comment'));
      return false;
    }
  };

  return { unresolveComment };
};
